import { useState } from 'react';
import { Link } from 'react-router-dom';
import { melbourneDate } from '../../../shared/dates';
import { formatDayMonth } from '../../components/primitives';
import { STATUS_CLASS, STATUS_LABEL } from './constants';
import type { AutomationEmailRow } from './types';

export function HistoryBlock({ rows }: { rows: AutomationEmailRow[] }) {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? rows : rows.slice(0, 5);

  return (
    <div className="atm-history">
      <div className="atm-history-head">
        <span className="h">Recent sends</span>
        <span className="n">{rows.length === 0 ? 'none yet' : `showing ${visible.length} of ${rows.length}`}</span>
      </div>
      {rows.length === 0 && <div className="empty-note">Nothing sent yet.</div>}
      {visible.map((row) => {
        const body = (
          <>
            <span className="atm-hist-date">{formatDayMonth(melbourneDate(row.created_at))}</span>
            <span className="atm-hist-to" title={row.to_email ?? undefined}>
              {row.to_email ?? '—'}
            </span>
            <span className="atm-hist-main">
              <span className="atm-hist-subject">{row.subject ?? '(no subject)'}</span>
              {row.error && <div className="atm-hist-reason">{row.error}</div>}
            </span>
            <span className={`atm-hist-status ${STATUS_CLASS[row.status]}`}>{STATUS_LABEL[row.status]}</span>
          </>
        );
        return row.project_id ? (
          <Link className="atm-hist-row" to={`/projects/${row.project_id}`} key={row.id}>
            {body}
          </Link>
        ) : (
          <div className="atm-hist-row" key={row.id}>
            {body}
          </div>
        );
      })}
      {!showAll && rows.length > 5 && (
        <button type="button" className="show-more" onClick={() => setShowAll(true)}>
          Show all {rows.length} →
        </button>
      )}
    </div>
  );
}
